import { ProjectsApi } from 'api'
import { Dispatch } from 'redux'
import { CatalogAction, CatalogActionTypes } from 'store/types/catalog'
import { emptyGenres } from 'pages/Catalog/common'

export type ProjectsWithFilter = {
  size?: number
  offset?: number
  // при изменении названия параметра поменять и в админке корп сайта
  draftListId?: string
  ProjectType?: number[]
  searchString?: string
  genre?: number[]
  sortField?: string
  sortDirection?: number
  SpecialCategoryType?: number[]
  displayOnHomePage?: boolean
}

const projectsApi = new ProjectsApi()

export const fetchProjects = (
  isMore = false,
  filters: ProjectsWithFilter = {}
) => {
  return async (dispatch: Dispatch<CatalogAction>): Promise<void> => {
    try {
      dispatch({ type: CatalogActionTypes.FETCH_CATALOG })

      const result = await getProjects(filters)

      dispatch({
        type: isMore
          ? CatalogActionTypes.FETCH_CATALOG_SUCCESS_MORE
          : CatalogActionTypes.FETCH_CATALOG_SUCCESS,
        payload: {
          items: result?.data?.data || [],
          total: result?.data?.count || 0,
          genres: result?.data?.genres || emptyGenres,
        },
      })
    } catch (e) {
      dispatch({
        type: CatalogActionTypes.FETCH_CATALOG_ERROR,
        payload: 'Произошла ошибка при загрузке',
      })
    }
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function getProjects(filters: ProjectsWithFilter = {}) {
  const {
    draftListId,
    size,
    offset,
    ProjectType,
    searchString,
    genre,
    sortField,
    sortDirection,
    SpecialCategoryType,
    displayOnHomePage,
  } = filters

  if (draftListId) {
    return projectsApi.getProjectsListWithDraft(
      draftListId,
      size,
      offset,
      displayOnHomePage,
      ProjectType,
      searchString,
      genre,
      sortField,
      sortDirection,
      SpecialCategoryType
    )
  }

  return projectsApi.getProjectsListPublished(
    size,
    offset,
    displayOnHomePage,
    ProjectType,
    searchString,
    genre,
    sortField,
    sortDirection,
    SpecialCategoryType
  )
}
